import * as React from "react";
import type { SVGProps } from "react";
const SvgDrafting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={64}
    fill="none"
    {...props}
  >
    <path
      stroke="#D3ECF8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M10.209 59.353v3.648M17.502 59.353v3.648M24.796 59.353v3.648M32.09 59.353v3.648"
    />
    <path
      stroke="#26A3DD"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M1.699 19.236V63H46.07L1.699 19.236Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M10.207 36.863v18.235h17.019l-17.02-18.235ZM48.236 41.686l3.228 8.677-8.51-3.646m5.282-5.03-5.282 5.03m5.282-5.03-26.829-28.17-5.282 5.03 26.83 28.17"
    />
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m17.008 9 3.773 3.96-5.282 5.031-3.773-3.96L17.008 9Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m28.23 12.192-3.227-8.677 8.51 3.647m-5.282 5.03 5.282-5.03m-5.282 5.03 26.829 28.17 5.282-5.03-26.83-28.17M55.061 40.362l3.773 3.962 5.282-5.03-3.773-3.962"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeWidth={1.75}
      d="M55.184 40.51 64.302 32l-6.687-6.686"
    />
  </svg>
);
export default SvgDrafting;
